const resourceStatusSelect = document.getElementById('resource-status-select')
if (resourceStatusSelect) {
    const blockedReasonSelect = document.getElementById('blocked-reason-select');
    const purchasePriceInput = document.getElementById('purchase-price-input')
    let blockedReason = blockedReasonSelect.value
    let purchasePrice = purchasePriceInput.value

    function toggleSelectReason() {
        const selectReasonContainer = document.getElementById('resource-blocked-reason-container')
        const purchasePriceContainer = document.getElementById('purchase-price-container')
        const messageContainer = document.getElementById('message-container')
        const submitBtnContainer = document.getElementById('submit-btn-container')
        switch (resourceStatusSelect.value) {
            case 'rejected':
            case 'blocked':
                selectReasonContainer.classList.remove('hidden')
                purchasePriceContainer.classList.add('hidden')
                messageContainer.classList.remove('hidden')
                submitBtnContainer.classList.remove('hidden')
                blockedReasonSelect.setAttribute('required', 'required')
                purchasePriceInput.removeAttribute('required')
                purchasePrice = purchasePriceInput.value
                purchasePriceInput.value = null
                blockedReasonSelect.value = blockedReason
                break
            case 'offer_sent':
                selectReasonContainer.classList.add('hidden')
                purchasePriceContainer.classList.remove('hidden')
                submitBtnContainer.classList.remove('hidden')
                messageContainer.classList.remove('hidden')
                purchasePriceInput.setAttribute('required', 'required')
                blockedReasonSelect.removeAttribute('required')
                purchasePriceInput.value = purchasePrice
                blockedReason = blockedReasonSelect.value
                blockedReasonSelect.value = ''
                break
            case 'accepted':
                selectReasonContainer.classList.add('hidden')
                purchasePriceContainer.classList.add('hidden')
                messageContainer.classList.add('hidden')
                submitBtnContainer.classList.remove('hidden')
                break
            default:
                selectReasonContainer.classList.add('hidden')
                purchasePriceContainer.classList.add('hidden')
                messageContainer.classList.add('hidden')
                submitBtnContainer.classList.add('hidden')
        }
    }

    toggleSelectReason()
    resourceStatusSelect.addEventListener('change', toggleSelectReason)
}
